{
  "changeLogTitle": "Journal des modifications",
  "help": {
    "tooltip": "Ce qui est suivi",
    "title": "Ce qui est suivi dans le journal des modifications",
    "layersCreatedDeleted": "Créations et suppressions de couches.",
    "mapObjectsGrouped": "Créations, suppressions et modifications de géométrie d'objets cartographiques groupées par utilisateur et par heure.",
    "mapObjectEditHint": "Les modifications d'objets cartographiques uniques sont considérées comme une modification si elles se produisent à moins de 5 minutes d'intervalle.",
    "layerOperationsGrouped": "Opérations de copie, d'importation et de dissociation de couches."
  },
  "dateTimes": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "todayAt": "Aujourd'hui à {{ time }}",
    "yesterdayAt": "Hier à {{ time }}",
    "dayAt": "{{ day }} à {{ time }}",
    "aWeekAgo": "Il y a une semaine",
    "weekday0": "dimanche",
    "weekday1": "Lundi",
    "weekday2": "Mardi",
    "weekday3": "Mercredi",
    "weekday4": "Jeudi",
    "weekday5": "Vendredi",
    "weekday6": "samedi"
  },
  "labels": {
    "layerFallbackName": "Couche",
    "multipleLayers": "Plusieurs couches",
    "viewDetails": "Afficher les détails"
  },
  "subTitles": {
    "layerImported": "Couche importée",
    "layersImported": "Couches importées",
    "layerUnlinked": "Couche non liée",
    "layersUnlinked": "Couches non liées",
    "layerCopied": "Couche copiée",
    "layersCopied": "Calques copiés",
    "layerCreated": "Couche créée",
    "layerDeleted": "Couche supprimée",
    "layerEdited": "Couche modifiée"
  },
  "details": {
    "layerImported": "Couche importée : {{ layerName }}",
    "layerUnlinked": "Couche non liée : {{ layerName }}",
    "layerCreated": "Couche créée : {{ layerName }}",
    "mapObjectCreated": "{{ count }} Objet cartographique créé",
    "mapObjectsCreated": "{{ count }} Objets cartographiques créés",
    "mapObjectUpdated": "{{ count }} Objet cartographique modifié",
    "mapObjectsUpdated": "{{ count }} Objets cartographiques modifiés",
    "mapObjectDeleted": "{{ count }} Objet cartographique supprimé",
    "mapObjectsDeleted": "{{ count }} Objets cartographiques supprimés"
  }
}